module.exports = __webpack_public_path__ + "static/media/A1-20-Qhizol-cod118.0fb90a0d.png";